<template>
  <div class="radio radio-custom radio-primary">
    <input
      type="radio"
      ref="input"
      v-bind:id="'filter_' + option.name"
      v-bind:name="option.name"
      v-bind:value="checkValue"
      class="kno-filter"
      :checked="isSelected"
      v-on:change.prevent="updateSelection"
    />
    <label v-bind:for="'filter_' + option.name">{{ option.text }}</label>
  </div>
</template>
<script>
import {
  ADD_FILTER_SELECTION,
  REMOVE_FILTER_SELECTION,
} from "@/vuex/mutation-types";

export default {
  props: ["option", "moduleName", "groupName"],
  data: function () {
    return {};
  },
  computed: {
    $this: function () {
      return this;
    },
    value: function () {
      var value = this.option.id;
      return value;
    },
    checkValue: function () {
      if (Array.isArray(this.option.id)) return this.option.id[0];
      else return this.option.id;
    },
    selectionArr() {
      return (
        this.$store.state[this.moduleName].filters.filtersSelection[
          this.groupName
        ] || []
      );
    },
    isSelected() {
      return this.selectionArr.some((id) => {
        return Array.isArray(this.value)
          ? this.value.indexOf(id) > -1
          : this.value == id;
      });
    },
  },
  methods: {
    updateSelection() {
      if (!this.isSelected) {
        //Add to selection
        this.$store.commit(
          this.moduleName + "/filters/" + ADD_FILTER_SELECTION,
          { name: this.groupName, value: this.value }
        );
      } else {
        //remove from selection
        this.$store.commit(
          this.moduleName + "/filters/" + REMOVE_FILTER_SELECTION,
          { name: this.groupName, value: this.value }
        );
      }
    },
  },
};
</script>
